import React from 'react';
import { Tooltip } from 'antd';

interface ShipmentTableProductCellProps {
  label: string;
  productNames: string;
}

const ShipmentTableProductCell: React.FC<ShipmentTableProductCellProps> = ({
  label,
  productNames,
}) => {
  return (
    <Tooltip title={productNames || undefined} mouseEnterDelay={0}>
      <span className='shipment-grid-text-cell' style={{ maxWidth: 180 }}>
        {label}
      </span>
    </Tooltip>
  );
};

export default ShipmentTableProductCell;
